import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// The native apps show a modal in its own web view, so a save there can't
// update the routine page behind it directly. This hands that page the
// redrawn sections over a BroadcastChannel (routine_handoff_receiver_controller.js)
// and closes the modal once the page confirms, which spares a second request
// for the whole page. When nothing confirms in time (the page behind isn't the
// routine, or isn't on screen), the modal closes by refreshing that page.
export const ROUTINE_HANDOFF_CHANNEL = "routine-handoff"
const CONFIRM_TIMEOUT = 400

export default class extends Controller {
  static targets = [ "streams" ]
  static values = { routineId: String, closeUrl: String, refreshUrl: String }

  connect() {
    if (typeof BroadcastChannel === "undefined") return this.leave(this.refreshUrlValue)

    const id = `${Date.now()}-${Math.random().toString(36).slice(2)}`
    this.channel = new BroadcastChannel(ROUTINE_HANDOFF_CHANNEL)
    this.channel.onmessage = (event) => {
      if (event.data?.type === "applied" && event.data.id === id) this.leave(this.closeUrlValue)
    }
    this.timeout = setTimeout(() => this.leave(this.refreshUrlValue), CONFIRM_TIMEOUT)

    this.channel.postMessage({
      type: "update",
      id,
      routineId: this.routineIdValue,
      streams: this.streamsTarget.innerHTML
    })
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.channel?.close()
  }

  leave(url) {
    if (this.left) return

    this.left = true
    clearTimeout(this.timeout)
    this.channel?.close()
    // A save that answers with streams leaves Turbo's cached pages here as
    // they were before it, and this page is out of date too. The modal's web
    // view is reused, so either would show as the preview, old settings and
    // all, the next time a modal opens this step.
    Turbo.cache.clear()
    Turbo.cache.exemptPageFromCache()
    Turbo.visit(url)
  }
}
